import CloseButton from "../closeButton/CloseButton";
import "./ToolPopUp.css";

const ToolPopUp = ({ title, children, isOpen, position = "bottom", onClose }) => {
  if (!isOpen) return null;

  return (
    <div className={`tool-pop-up ${isOpen ? "active" : ""} ${position}`}>
      <div className="tool-pop-up-content">
        <div className="tool-pop-up-header">
          <div className="App-text-large ">{title}</div>
          {onClose && <CloseButton onClose={onClose} />}
        </div>
        <div className="tool-pop-up-body">{children}</div>
      </div>
    </div>
  );
};

export default ToolPopUp;
